import rightTriangular from '../../../../../../assests/notAuth/rightTriangular.png'
import leftTriangular from '../../../../../../assests/notAuth/leftTriangular.png'
import classes from './LogosIcon.module.css';

const LogosIcon = ({ logosIcon, video }) => {

    const isYouTubeVideo = video && (video.includes('youtube.com') || video.includes('youtu.be'));

    const renderVideoContent = () => {
        if (isYouTubeVideo) {
            return (
                <iframe
                    className={classes.Video}
                    src={video}
                    title="YouTube video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            );
        }

        return <img className={`${classes.Video} ${classes.Gif}`} src={video} alt="video content" />;
    };

    return (
        <div className={`${classes.LogosSection} ${classes.InfoSection}`}>
            <div className={classes.LogosIcon}>
                {logosIcon?.map(logoIcon => <img className={classes.LogoIcon} src={logoIcon} alt={logoIcon} />)}
            </div>
            <div className={classes.GifContainer}>
                <img className={classes.RightTriangular} src={rightTriangular} alt='' />
                {renderVideoContent()}
                <img className={classes.LeftTriangular} src={leftTriangular} alt='' />
            </div>
        </div>
    )
}
export default LogosIcon;